import { render, staticRenderFns } from "./VideoDescription.vue?vue&type=template&id=6fd402f6&scoped=true&"
import script from "./VideoDescription.vue?vue&type=script&lang=js&"
export * from "./VideoDescription.vue?vue&type=script&lang=js&"
import style0 from "./VideoDescription.vue?vue&type=style&index=0&id=6fd402f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd402f6",
  null
  
)

export default component.exports